import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { SortDirection } from '../components/table/sortable-header';

type DirectReportData = {
	activeGoalCount?: number | null;
	deletedAt: string | false | null;
	displayName: string;
	lastCheckInDate: string;
	lastCheckInScore: number;
	oneOnOneUpdated?: boolean | null;
	profilePicUrl: string;
	recognitionManagerCount: number;
	totalRecognitionCount?: number | null;
	upcomingOneOnOneDate?: string | null;
	userId: string;
	username: string;
};

type DirectReportsOverviewResponse = DirectReportData[];

type Params = {
	sortBy: string;
	sortDirection: SortDirection;
	enabled?: boolean;
};

const directReportsOverviewQueryKey = (sortBy: string, sortDirection: SortDirection) => ['direct-reports-overview', sortBy, sortDirection];

export const useDirectReportsOverview = (params: Params) => {
	const http = useHttpClient();
	return useQuery(
		directReportsOverviewQueryKey(params.sortBy, params.sortDirection),
		async () => {
			const res = await http.get<DirectReportsOverviewResponse>('/analytics/team/direct_team/direct_reports_overview', {
				headers: {
					'Key-Inflection': 'camel',
				},
				params: {
					sort_by: params.sortBy,
					sort_direction: params.sortDirection,
				},
			});

			return res.data;
		},
		{
			retry: false,
			refetchOnWindowFocus: false,
			enabled: params.enabled,
		}
	);
};
